<div class="flex justify-between items-center">
  <app-addresses-details [origin]="route.formValues.origin.addressDetails.label" [destination]="route.formValues.destination.addressDetails.label" (click)="onPickFavoriteClick.emit()"/>

  @if (!!showActionButtons) {
    <div class="flex items-center">
      <!-- a11y: same rationale as favorite-line — icon-only buttons need
           an explicit aria-label (passed down from manage-favorites). -->
      <mot-button matType="icon" icon="pen" [ariaLabel]="editAriaLabel" ariaHaspopup="dialog" (onClick)="onEditButtonClick.emit()" />
      <mot-button matType="icon" icon="trash" [ariaLabel]="deleteAriaLabel" ariaHaspopup="dialog" (onClick)="onDeleteButtonClick.emit()" />
    </div>
  }
</div>